import { useContext } from "react";

import { AppContext } from "../../../../core/context/appContextProvider";
import { DistributionTeamMembers } from "../../../../utils/types/distributions.type";
import {
  DISTRIBUTION_REVIEW_VALIDATION_ERROR,
  DistributionReviewersList,
} from "../Constants";

type Props = {
  value?: { name?: string }[] | null;
  onChange: (value?: { name?: string }[] | null) => void;
  teamMembers: DistributionTeamMembers;
  errorMessage: any;
  setErrorMessage: (value: any) => void;
};

export const useDistributionReviewers = ({
  value,
  onChange,
  teamMembers,
  errorMessage,
  setErrorMessage,
}: Props) => {
  const isChecked = (reviewer: string) =>
    Boolean(
      value?.find(
        (item) => item?.name?.toLowerCase() === reviewer?.toLowerCase()
      )
    );
  const { state } = useContext(AppContext);
  const handleChange = (reviewer: string) => {
    const currentValue = [...(value || [])];
    const currentIndex = currentValue?.findIndex(
      (item) => item?.name?.toLowerCase() === reviewer?.toLowerCase()
    );

    if (currentIndex === -1) {
      onChange([
        ...currentValue,
        {
          name: reviewer,
        },
      ]);
      handleValidateReviewer(reviewer);
    } else {
      currentValue.splice(currentIndex, 1);
      onChange([...currentValue]);
      setErrorMessage(changeErrorMessage(reviewer, false));
    }
  };

  const selectReviewer = (member: string) => {
    switch (member) {
      case DistributionReviewersList.Associate:
        return "Associate";
      case DistributionReviewersList.Director:
        return "Director";
      case DistributionReviewersList.FundController:
        return "Fund Controller";
      case DistributionReviewersList.FundUserReadOnly:
        return "Fund User Read Only";
      case DistributionReviewersList.Manager:
        return "Manager";
      default:
        return "";
    }
  };

  const handleValidateReviewer = (reviewer: string) => {
    if (
      teamMembers[reviewer.trim() as keyof DistributionTeamMembers] ===
      undefined
    ) {
      setErrorMessage(changeErrorMessage(reviewer, true));
    } else {
      const filteredTeamMembers =
        teamMembers[reviewer.trim() as keyof DistributionTeamMembers]?.filter(
          (user) =>
            user?.toLowerCase() !==
            state.loginUser.currentUser?.username?.toLowerCase()
        ) || [];

      if (filteredTeamMembers.length === 0) {
        setErrorMessage(changeErrorMessage(reviewer, true));
      } else {
        setErrorMessage(changeErrorMessage(reviewer, false));
      }
    }
  };
  const changeErrorMessage = (reviewer: string, checked: boolean) => {
    switch (reviewer) {
      case DistributionReviewersList.Associate:
        return checked
          ? {
              ...errorMessage,
              ASSOCIATE:
                "There should be at least one user in reviewer you select",
            }
          : { ...errorMessage, ASSOCIATE: "" };
      case DistributionReviewersList.Director:
        return checked
          ? {
              ...errorMessage,
              DIRECTOR: DISTRIBUTION_REVIEW_VALIDATION_ERROR,
            }
          : { ...errorMessage, DIRECTOR: "" };
      case DistributionReviewersList.FundController:
        return checked
          ? {
              ...errorMessage,
              FUND_CONTROLLER: DISTRIBUTION_REVIEW_VALIDATION_ERROR,
            }
          : { ...errorMessage, FUND_CONTROLLER: "" };
      case DistributionReviewersList.FundUserReadOnly:
        return checked
          ? {
              ...errorMessage,
              FUND_USER_READ_ONLY: DISTRIBUTION_REVIEW_VALIDATION_ERROR,
            }
          : { ...errorMessage, FUND_USER_READ_ONLY: "" };
      case DistributionReviewersList.Manager:
        return checked
          ? {
              ...errorMessage,
              MANAGER: DISTRIBUTION_REVIEW_VALIDATION_ERROR,
            }
          : { ...errorMessage, MANAGER: "" };
      default:
        return { ...errorMessage };
    }
  };

  return {
    isChecked,
    selectReviewer,
    handleChange,
  };
};
